module.exports = __webpack_public_path__ + "assets/img/appointment_bg.c3b2ab12.png";